import { Tooltip } from "antd";
import { useTexts } from "hooks/useTexts";
import React, { useRef } from "react";
import BubbleButton from "ui/BubbleButton";

type EditingButtonsProps = {
  canShowSaveEditedButton: boolean;
  canShowSaveToDraftButton: boolean;
  canShowPublishButton: boolean;
  contentIsSubmittable: boolean;
  submitTooltipText: string;
  isReviewingMode: boolean;
  onSaveEditedClick: () => void;
  onSaveToDraftClick: () => void;
  onSaveAndPublishClick: () => void;
  closeModal: () => void;
};

const EditingButtons: React.FC<EditingButtonsProps> = ({
  canShowSaveEditedButton,
  canShowSaveToDraftButton,
  canShowPublishButton,
  contentIsSubmittable,
  submitTooltipText,
  isReviewingMode,
  onSaveEditedClick,
  onSaveToDraftClick,
  onSaveAndPublishClick,
  closeModal,
}) => {
  const { txt } = useTexts("card");
  const refSaveButton = useRef(null);

  return (
    <>
      {canShowSaveEditedButton && (
        <>
          &nbsp;
          <Tooltip
            placement="bottomRight"
            title={!contentIsSubmittable ? submitTooltipText : ""}
          >
            <span>
              <BubbleButton
                ref={refSaveButton}
                className="right"
                size="m"
                onClick={onSaveEditedClick}
                text={
                  isReviewingMode
                    ? txt("approve", "Утвердить")
                    : txt("save", "Сохранить")
                }
                autosize={false}
                square={false}
                disabled={!contentIsSubmittable}
              />
            </span>
          </Tooltip>
        </>
      )}
      {canShowSaveToDraftButton && (
        <>
          &nbsp;
          <Tooltip
            placement="bottomRight"
            title={!contentIsSubmittable ? submitTooltipText : ""}
          >
            <span>
              <BubbleButton
                className="right"
                size="m"
                onClick={onSaveToDraftClick}
                text={txt("to_draft", "В черновик")}
                autosize={false}
                square={false}
                disabled={!contentIsSubmittable}
              />
            </span>
          </Tooltip>
        </>
      )}
      {canShowPublishButton && (
        <>
          &nbsp;
          <Tooltip
            placement="bottomRight"
            title={!contentIsSubmittable ? submitTooltipText : ""}
          >
            <span>
              <BubbleButton
                className="right"
                size="m"
                onClick={onSaveAndPublishClick}
                text={txt("publish", "Опубликовать")}
                autosize={false}
                square={false}
                disabled={!contentIsSubmittable}
              />
            </span>
          </Tooltip>
        </>
      )}
      &nbsp;
      <BubbleButton
        className="right"
        size="m"
        onClick={closeModal}
        text={txt("cancel", "Отмена")}
        autosize={false}
        square={false}
      />
    </>
  );
};

export default EditingButtons;
